export default __webpack_public_path__ + "static/media/FunctionalStrengthTrainingHero.40c2e6ab.png";